"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AppUserMenu = void 0;
const lib_env_1 = __importDefault(require("@opsbase/lib-env"));
const lib_i18n_1 = __importDefault(require("@opsbase/lib-i18n"));
const lib_pages_1 = __importDefault(require("@opsbase/lib-pages"));
const lib_palette_1 = __importDefault(require("@opsbase/lib-palette"));
const lib_storage_1 = require("@opsbase/lib-storage");
const App_1 = __importDefault(require("@opsbase/lib-system/App/App"));
const useSelf_1 = __importDefault(require("@opsbase/react-ctrl-self/useSelf"));
const useSelfActions_1 = __importDefault(require("@opsbase/react-ctrl-self/useSelfActions"));
const useOrgs_1 = __importDefault(require("@opsbase/react-gql-hooks/organisation/useOrgs"));
const useAppState_1 = __importDefault(require("@opsbase/web-app-state/useAppState/useAppState"));
const web_css_1 = __importDefault(require("@opsbase/web-css"));
const AvatarIcon_1 = __importDefault(require("@opsbase/web-icons/icons/AvatarIcon"));
const Vertical_1 = __importDefault(require("@opsbase/web-layout/Vertical/Vertical"));
const useNav_1 = __importDefault(require("@opsbase/web-nav/useNav"));
const Avatar_1 = __importDefault(require("@opsbase/web-ui/Avatar"));
const IconMenu_1 = __importDefault(require("@opsbase/web-ui/IconMenu"));
const MenuItem_1 = __importDefault(require("@opsbase/web-ui/MenuItem"));
const Text_1 = __importDefault(require("@opsbase/web-ui/Text"));
const react_1 = __importStar(require("react"));
const react_router_dom_1 = require("react-router-dom");
const makeMyClasses = () => ({
    main: {
        minWidth: 200,
        backgroundColor: lib_palette_1.default.HelixSecondaryBoldAccent.main,
        color: 'white',
    },
    secondary: {
        backgroundColor: lib_palette_1.default.GreyBlue.main,
        color: 'white',
    },
    autoRoot: {
        padding: '0 16px',
        marginTop: 8,
    },
    button: {
        padding: 0,
        width: 50,
        height: 50,
    },
});
const AppUserMenu = function ({ version }) {
    const [keyword] = (0, react_1.useState)();
    const asyncCb = (0, react_1.useRef)();
    const { app } = (0, useAppState_1.default)();
    const { goTo } = (0, useNav_1.default)();
    const realSelf = (0, useSelf_1.default)(true);
    const self = (0, useSelf_1.default)();
    const { setShadow } = (0, useSelfActions_1.default)();
    const { pathname } = (0, react_router_dom_1.useLocation)();
    const [showIds, setShowIds] = (0, react_1.useState)(false);
    const myCss = (0, web_css_1.default)(makeMyClasses);
    const { loading, data: orgs } = (0, useOrgs_1.default)({
        variables: { keyword },
        skip: !keyword,
    });
    const isShadowing = self.id !== realSelf.id;
    const selfTitle = self.title;
    const selfId = self.id;
    const realSelfTitle = realSelf.title;
    const orgTitle = self.organisationTitle;
    const orgId = self.organisationId;
    const hasAuthSwitcher = realSelf.isSuperUser && app === App_1.default.OPSBASE;
    const hasGraphQL = lib_env_1.default.enableGraphQLPlayground && (realSelf.isSuperUser || realSelf.isPrimary);
    const handleSwitch = (0, react_1.useCallback)(() => {
        (0, lib_storage_1.setStoredValue)('lastOrg', self.organisationId + '###' + self.organisationTitle);
        setShadow(undefined);
        (0, lib_storage_1.removeStoredValue)('shadowAccessToken');
        (0, lib_storage_1.removeStoredValue)('shadowRefreshToken');
        goTo(lib_pages_1.default.AUTH_SWITCH);
    }, [goTo, self.organisationId, self.organisationTitle, setShadow]);
    (0, react_1.useEffect)(() => {
        if (!loading && orgs) {
            if (asyncCb.current)
                asyncCb.current(orgs.map(item => ({ value: item, label: item.title })));
            asyncCb.current = undefined;
        }
    }, [loading, orgs]);
    const icon = !!self && self.hasProfileImage ? (react_1.default.createElement(Avatar_1.default, { user: self, size: 32 })) : (react_1.default.createElement(AvatarIcon_1.default, { color: lib_palette_1.default.LavendarGrey, size: 32 }));
    const handleToggleIds = (0, react_1.useCallback)(e => {
        e.stopPropagation();
        if (!isShadowing)
            return;
        setShowIds(!showIds);
    }, [isShadowing, showIds]);
    return (react_1.default.createElement(IconMenu_1.default, { small: true, color: lib_palette_1.default.White, tooltip: lib_i18n_1.default.t('settings-menu'), icon: icon },
        react_1.default.createElement(Vertical_1.default, { padding: true, classes: { root: myCss.main }, onClick: e => e.stopPropagation() },
            react_1.default.createElement(Text_1.default, null, selfTitle),
            showIds && react_1.default.createElement(Text_1.default, null, selfId),
            react_1.default.createElement(Text_1.default, null, orgTitle),
            showIds && react_1.default.createElement(Text_1.default, null, orgId)),
        (!!lib_env_1.default.showEnvName || !!isShadowing) && (react_1.default.createElement(Vertical_1.default, { padding: true, classes: { root: myCss.secondary }, onClick: handleToggleIds },
            !!isShadowing && react_1.default.createElement(Text_1.default, null, realSelfTitle),
            !!lib_env_1.default.showEnvName && react_1.default.createElement(Text_1.default, null, lib_env_1.default.envName))),
        react_1.default.createElement(MenuItem_1.default, { link: lib_pages_1.default.PROFILE.replace('*', pathname), label: lib_i18n_1.default.t('my-profile') }),
        !!hasAuthSwitcher && react_1.default.createElement(MenuItem_1.default, { onClick: handleSwitch, label: lib_i18n_1.default.t('switch-user') }),
        !!hasGraphQL && react_1.default.createElement(MenuItem_1.default, { link: lib_pages_1.default.GRAPHQL, label: lib_i18n_1.default.t('graphql-playground') }),
        react_1.default.createElement(MenuItem_1.default, { link: '/signout', label: lib_i18n_1.default.t('sign-out') }),
        react_1.default.createElement(Vertical_1.default, { padding: true },
            react_1.default.createElement(Text_1.default, { variant: 'small', color: 'grey', centered: true }, 'Ideagen Smartforms Essentials'),
            version ? (react_1.default.createElement(Text_1.default, { variant: 'small', color: 'grey', centered: true }, 'v' + version)) : null)));
};
exports.AppUserMenu = AppUserMenu;
exports.default = exports.AppUserMenu;
